const codigoProcesso = {

  NAO_ONEROSO: 'NAO_ONEROSO',
  ONEROSO: 'ONEROSO',
  TEQ: 'TEQ',
  PEAS: 'PEAS',
  PEAEX: 'PEAEX',
  REGULARIZACAO_URBANA: 'REGULARIZACAO_URBANA',
  CERTIDAO_TITULO: 'CERTIDAO_TITULO'

}

export default codigoProcesso



// WEBPACK FOOTER //
// ./src/utils/tipoProcesso.js